<template>
  <v-main>
    <v-app-bar flat style="background-color: #FFFFFF;" height="98">
      <v-toolbar-title style="height: 98px; margin-left: 10%;">
        <div class="iconNavBar">
          <v-img alt="Vuetify Logo" src="@/assets/group-5.svg" contain transition="scale-transition"
            style="height: 75%;" />

        </div>
      </v-toolbar-title>

      <v-toolbar-items class="ms-3" v-if="$vuetify.breakpoint.mdAndUp">
        <v-btn v-for="(item, index) in menu" :key="item.id" text v-if="item.show" class="i"
          style="color: #6a707e; font-size: 16px; font-weight: bold;" :class="{ 'over-on-item': overOnItem === index }"
          @click="selectedItFunc(index, item.link)" @mouseover="addUnderlineNav(index)"
          @mouseout="removeUnderlineNav(index)">
          <div class="path-23-parent" style="margin-left: 25px; margin-right: 10px;"
            v-if="item.icon === '/img/path-23.1e7b2424.svg'">
            <img :src="item.icon" class="path-23-icon" />
            <div class="group-item"></div>
            <div class="group-inner"></div>
          </div>
          <img v-else style="margin-left: 25px; margin-right: 10px;" alt="" :src="item.icon" />
          {{ item.title }}
        </v-btn>
      </v-toolbar-items>

      <v-spacer></v-spacer>

      <div class="d-flex justify-end pt-3 pl-3">
        <div v-if="role !== 'admin'" class="user-info hidden-sm-and-down"
          style="display: flex; justify-content: center; align-items: center; margin-left: 40px;">
          <span class="mr-2" style="color: #6a707e; font-size: 16px; font-weight: bold;">יתרה לניצול</span>
          <span class="mr-2" style="font-size: 16px; font-weight: bold;"
            :class="[balance < 100 ? 'text-color-red' : 'text-color-grey']">{{ balance }} ש"ח</span>
        </div>
        <div class="user-info" style="display: flex; justify-content: center; align-items: center; margin-left: 40px;">
          <span class="mr-2" style="font-weight: 500; font-size: 16px; color: #6a707e;">{{ userName }}</span>
          <span class="mr-2" style="font-size: 16px; color: #6a707e;" @click="showLogs()">{{ email }}</span>
        </div>

        <v-tooltip bottom v-if="isAdmin">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" @click="swichToAdmin()" style="margin-left: 15px;">
              mdi-swap-horizontal
            </v-icon>
          </template>
          <span>חזור לניהול</span>
        </v-tooltip>

        <div v-if="$vuetify.breakpoint.mdAndUp">
          <div class="logout-button-container" @mouseover="isFocused = true" @mouseleave="isFocused = false"
            @click="logOut()">
            <v-img src="@/assets/log-out.svg"
              :style="{ width: isFocused ? '40px' : '34px', height: isFocused ? '46px' : '40px', marginRight: '20px', marginLeft: '20px', marginTop: '5px' }"
              class="image-transition" />
          </div>
        </div>

      </div>

      <div v-if="$vuetify.breakpoint.mdAndDown">

        <v-menu bottom left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-app-bar-nav-icon></v-app-bar-nav-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list>
              <v-list-item v-for="item in menu" :key="item.id" :to="item.link">
                <v-list-item-icon>
                  <div class="path-23-parent" style="margin-left: 25px; margin-right: 10px;"
                    v-if="item.icon === '/img/path-23.1e7b2424.svg'">
                    <img :src="item.icon" class="path-23-icon" />
                    <div class="group-item"></div>
                    <div class="group-inner"></div>
                  </div>
                  <img v-else style="margin-left: 25px; margin-right: 10px;" alt="" :src="item.icon" />
                </v-list-item-icon>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
            <v-list-item :key="'logout'" @click="logOut()">
              <v-list-item-action>
                <v-img src="@/assets/log-out.svg" />
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Logout</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-app-bar>

  </v-main>
</template>

<script>
import Auth from '@/services/auth.service.js'

export default {
  props: {
    balanceChanged: Number,
  },
  data() {
    return {
      menu: [],
      sellerMenu: [
        { id: "seller", title: "סטטיסטיקות", link: "/seller", show: true, icon: require("@/assets/group-11.svg") },
        { id: "seller_activate", title: "דף טעינה", link: "/seller_activate", show: true, icon: require("@/assets/group-17.svg") },
        { id: "seller_esim", title: "חיבור ESIM", link: "/seller_esim", show: true, icon: require("@/assets/group-17.svg") },
        { id: "seller_reports", title: "דוח טעינות", link: "/seller_reports", show: true, icon: require("@/assets/path-23.svg") },
        { id: "seller_account", title: "אזור אישי", link: "/seller_account", show: true, icon: require("@/assets/group-20.svg") },
      ],
      adminMenu: [
        { id: "admin", title: "סטטיסטיקות", link: "/admin", icon: require("@/assets/group-11.svg"), show: true },
        { id: "admin_users_list", title: "ניהול משתמשים", link: "/admin_users_list", icon: require("@/assets/account.svg"), show: true },
        { id: "admin_codes", title: "קודים", link: "/admin_codes", icon: require("@/assets/code-tags.svg"), show: true },
        { id: "admin_white_list", title: "ניידים", link: "/admin_white_list", icon: require("@/assets/smartphone.svg"), show: true },
        { id: "admin_esims_list", title: "eSIMS", link: "/admin_esims_list", icon: require("@/assets/smartphone.svg"), show: true },
        { id: "admin_refund", title: "ביטולים", link: "/admin_refund", icon: require("@/assets/credit-card-refund-outline.svg"), show: true },
        { id: "admin_portin", title: "ניודים", link: "/admin_portin", icon: require("@/assets/smartphone.svg"), show: true }

      ],
      userName: "",
      email: "",
      balance: 0,
      role: "",
      isFocused: false,
      overOnItem: null,
      selectedNavItem: null,
      isAdmin: false
    }

  },
  methods: {

    logOut() {
      localStorage.removeItem("token");
      this.$router.replace({ name: "login" })
    },
    selectedItFunc(index, link) {
      this.$store.state.selectedNavItem = index;
      if (this.$route.path !== link) {
        this.$router.replace({ path: link })
      }
    },
    addUnderlineNav(index) {
      if (this.overOnItem !== index) {
        this.overOnItem = index;
      }
    },
    removeUnderlineNav() {
      this.overOnItem = this.$store.state.selectedNavItem;
    },
    setNavListIItems() {
      this.userName = Auth.getUserName();
      this.email = Auth.getUserEmail();
      this.role = Auth.getUserRole();
      if (this.role === "admin") {
        this.menu = this.adminMenu;
      } else {
        this.menu = this.sellerMenu;
      }
      if (localStorage.getItem("token2")) {
        this.isAdmin = true;
      }
    },
    swichToAdmin() {
      localStorage.setItem("token", localStorage.getItem("token2"));
      localStorage.removeItem("token2");
      this.$router.replace({ name: "login" });
    },
    showLogs() {
      if (this.role === "admin") {
        this.$router.push({ name: 'admin_logs' })
      }
    },
  },
  watch: {
    balanceChanged() {
      this.balance = localStorage.getItem('balance');
    },
  },
  created() {
    this.balance = localStorage.getItem('balance');
    this.setNavListIItems();

    // הוספת קו תחתון במידה ועושים ריענון לדף
    this.menu.forEach((item, index) => {
      if (this.$route.path === item.link) {
        this.overOnItem = index;
        this.selectedNavItem = index;
      }
    });
  },
}
</script>
<style>
.user-info {
  display: flex;
  flex-direction: column;
}

.user-info span {
  margin-right: 2px;
}

.logout-button-container {
  display: flex;
  align-items: center;
}

/* 
@font-face {
  font-family: 'Heebo';
  src: url('@/fonts/Heebo.ttf') format('truetype');
}

@font-face {
  font-family: 'Heebo';
  src: url('@/fonts/Heebo-Bold.ttf') format('truetype');
  font-weight: bold;
}
.i {
  font-family: 'Heebo', sans-serif;
} */

.text-color-red {
  color: rgb(202, 4, 4) !important;
  font-weight: 700;
}

.text-color-grey {
  color: #6a707e
}

.image-transition {
  transition: width 0.3s ease, height 0.3s ease;
  /* Adjust the animation duration and easing as needed */
}

.v-toolbar__content,
.v-toolbar__extension {
  padding: 0px;
}

.iconNavBar {
  background-color: #0099cd !important;
  width: 320px;
  display: flex;
  align-items: center;
  /* Center vertically */
  justify-content: center;
  /* Center horizontally */
  height: 100%;
  /* Make sure the container takes full height */
}

/* הוספה בתוך אייקון של דוח טעינות */
.path-23-parent {
  position: relative;
  display: inline-block;
}

.path-23-icon {
  display: block;
}

.group-inner,
.group-item {
  position: absolute;
  top: calc(50% - 2px);
  left: calc(50% - 4px);
  background-color: #0089c3;
  width: 8px;
  height: 2px;
}

.group-inner {
  top: calc(50% + 2px);
  background-color: #131a39;
  width: 5px;
}

.over-on-item {
  border-bottom: 3px solid #0089c3;
}
</style>